import photo1 from "/public/images/events/stages/stage-1ere-dan-25/photo1.webp";

export const stage1ereDan25 = [photo1];
